import { setWelcomeMessage } from "asos-site-chrome-store-presentation";

const setWelcomeMessageClosed = () => {
  setWelcomeMessage(true);
};

export default setWelcomeMessageClosed;
